<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Products
          </div>
          <div class="card-block">
            <table class="table table-bordered table-striped table-condensed">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Codename</th>
                  <th>Data provider</th>
                  <th>Type</th>
                  <th>Created</th>
                </tr>
              </thead>
              <tbody>
                <loading-rows v-if="loading" cols='5'/>
                <tr v-for="product in products" v-if="!loading">
                  <td>{{product.id}}</td>
                  <td><router-link :to="{ name: 'Product', params: {id: product.id} }">{{product.codename}}</router-link></td>
                  <td>{{product.data_provider}}</td>
                  <td>{{product.addon_type}}</td>
                  <td>{{product.created_at | moment('LLL')}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <pagination v-bind:totalEntries="pagination.total_entries" v-bind:totalPages="pagination.total_pages" v-bind:currentPage="pagination.current_page"></pagination>
      </div>
    </div>
  </div>

</template>

<script>

import products from 'services/products'
import Pagination from 'components/Pagination'
import LoadingRows from 'components/LoadingRows'

export default {
  name: 'products',
  created () {
    this.fetchData()
  },
  data () {
    return {
      products: [],
      loading: false,
      pagination: {},
      order: 'created_at desc'
    }
  },
  computed: {
    page () {
      if (this.$route.query.page) {
        return this.$route.query.page
      }
      return 1
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  components: {
    Pagination,
    LoadingRows
  },
  methods: {
    fetchData () {
      products.all(this)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Products.vue